export const accordionItems = [
  {
    title: 'Як вибрати правильний розмір одягу?',
    content: 'Додайте товар до кошика, виберіть спосіб доставки та оплати, і заверште оформлення замовлення.',
  },
  {
    title: 'Як оформити замовлення?',
    content: 'Додайте товар до кошика, виберіть спосіб доставки та оплати, і заверште оформлення замовлення.',
  },
  {
    title: 'Як повернути або обміняти товар?',
    content: 'Додайте товар до кошика, виберіть спосіб доставки та оплати, і заверште оформлення замовлення.',
  },
  {
    title: 'Чи можна отримати знижку на першу покупку?',
    content: 'Додайте товар до кошика, виберіть спосіб доставки та оплати, і заверште оформлення замовлення.',
  },
  {
    title: 'Як дізнатися статус свого замовлення?',
    content: 'Додайте товар до кошика, виберіть спосіб доставки та оплати, і заверште оформлення замовлення.',
  },
]
